// extracted by mini-css-extract-plugin
export default {"main":"AIRubricTotalMark_main__qqUCi"};